import type { Ref } from "vue";
import { ref, isRef, onMounted, onUpdated } from "vue";

/**
 * @function useChildCount - get a ref value of the amount of children in a html element
 * @param {Ref<null | HTMLElement>}element - template ref to the element
 * @param {number | Ref<number>} initial - initial value
 * @returns {Ref<number>} amount of children in the element
 */
export default function useChildCount(
  element: Ref<null | HTMLElement>,
  initial: number | Ref<number> = 1
): Ref<number> {
  /** @const {Ref<number>} childCount - the amount of children of the element*/
  const childCount = ref(isRef(initial) ? initial.value : initial);

  //update the childCount
  function updateChildCount() {
    childCount.value = element.value?.childElementCount
      ? element.value?.childElementCount
      : isRef(initial)
      ? initial.value
      : initial;
  }

  //calculate the children count when the component appears
  onMounted(() => {
    updateChildCount();
  });
  //recalculate when the component updates
  onUpdated(() => {
    updateChildCount();
  });

  return childCount;
}
